import { Clock } from 'lucide-react';
import GroupChoiceButtons from '../rsvp/GroupChoiceButtons';
import EventGroupRows from './EventGroupRows';

function queueMessage() {
  return "We'll match you with a group once more people RSVP";
}

/**
 * Festival event-page groups: your groups as Groups-page rows, or the waiting state.
 */
export default function FestivalGroupCard({
  groups = [],
  isInQueue,
  userStatus,
  onFindGroup,
  onCreateGroup,
  canFindGroup = false,
  onNavigate,
}) {
  const isGoing = userStatus === 'going';
  const hasGroups = groups.length > 0;

  if (!hasGroups && !isGoing) return null;

  if (hasGroups) {
    return (
      <section>
        <h2 className="lineup-section-label">{groups.length > 1 ? 'Your groups' : 'Your group'}</h2>
        <EventGroupRows groups={groups} onNavigate={onNavigate} />
      </section>
    );
  }

  return (
    <section>
      <h2 className="lineup-section-label">Your group</h2>
      <div className="lineup-section-card">
        {/* Going without a group: just the way to make or find one (Sam, 2026-10-26: no "You're going solo!" line). */}
        {/* Only a match-queue entry waits; going with no group (isSolo lags a fresh RSVP by a refetch) is Create / Find. */}
        {!isInQueue ? (
          <GroupChoiceButtons
            canFindGroup={canFindGroup}
            onCreateGroup={onCreateGroup}
            onFindGroup={onFindGroup}
          />
        ) : (
          <div className="flex items-start gap-3">
            <Clock
              className="mt-0.5 h-5 w-5 shrink-0 text-[var(--glass-accent-ring)]"
              aria-hidden
            />
            <p className="min-w-0 flex-1 text-xs leading-relaxed text-ink/75">{queueMessage()}</p>
          </div>
        )}
      </div>
    </section>
  );
}
